import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import api from "@/lib/api";
import { Users, FileCheck, FileText } from "lucide-react";

export default function GlobalSearch({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ clientes: [], contratos: [], solicitacoes: [] });
  const navigate = useNavigate();

  useEffect(() => {
    if (!q || q.length < 2) {
      setRes({ clientes: [], contratos: [], solicitacoes: [] });
      return;
    }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setRes(data);
      } catch { /* ignorado */ }
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (path) => {
    onOpenChange(false);
    setQ("");
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput
        placeholder="Buscar por nome, CPF, telefone, contrato..."
        value={q}
        onValueChange={setQ}
        data-testid="global-search-input"
      />
      <CommandList>
        <CommandEmpty>Digite ao menos 2 caracteres para buscar.</CommandEmpty>
        {res.clientes.length > 0 && (
          <CommandGroup heading="Clientes">
            {res.clientes.map((c) => (
              <CommandItem key={c.id} value={"cli" + c.id} onSelect={() => go(`/clientes/${c.id}`)} data-testid={`search-client-${c.id}`}>
                <Users className="w-4 h-4 mr-2 gold-text" /> {c.nome} <span className="ml-2 text-xs text-slate-400">{c.cpf}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {res.contratos.length > 0 && (
          <CommandGroup heading="Contratos">
            {res.contratos.map((c) => (
              <CommandItem key={c.id} value={"con" + c.id} onSelect={() => go(`/contratos/${c.id}`)}>
                <FileCheck className="w-4 h-4 mr-2 gold-text" /> {c.numero} <span className="ml-2 text-xs text-slate-400">{c.cliente_nome}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {res.solicitacoes.length > 0 && (
          <CommandGroup heading="Solicitações">
            {res.solicitacoes.map((c) => (
              <CommandItem key={c.id} value={"app" + c.id} onSelect={() => go(`/solicitacoes`)}>
                <FileText className="w-4 h-4 mr-2 gold-text" /> {c.nome} <span className="ml-2 text-xs text-slate-400">{c.cpf}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
